import React from "react";
import { Box, Stack, Theme, Tooltip } from "@mui/material";
import { GridColTypeDef, GridRenderCellParams } from "@mui/x-data-grid";
import { i18n } from "i18next";
import { useTranslation } from "react-i18next";
import { useTheme } from '@mui/material';

import baseColumn from "./BaseColumn";
import { fieldLabelFormat } from "../TableUtils";
import { toISOPercent } from "components/formatting/ISOPercentage";

export interface DistributionBarOptions {
  backgroundColor?: string;
  fillColor?: string;
  headerLabels?: Record<string, string>;
}

export function renderDistributionBarColumn(i18n: i18n, theme: Theme, params: GridRenderCellParams, options?: DistributionBarOptions): React.JSX.Element {
  const fillColor = options?.fillColor ?? theme.colors.info.main;
  const backgroundColor = options?.backgroundColor ?? theme.colors.namedColors.neutralLight;
  const value = toISOPercent(i18n, params.value);
  
  return (
    <Tooltip followCursor title={value}>
      <Stack
        direction="row"
        sx={{
          paddingTop: 1,
          paddingBottom: 1,
          width: "100%",
          height: "100%"
        }}>
        <Box
          sx={{
            width: "100%",
            backgroundColor: backgroundColor
          }}>
          <Box
            sx={{
              width: `${params.value * 100}%`,
              height: "100%",
              backgroundColor: fillColor
            }}></Box>
        </Box>
      </Stack>
    </Tooltip>
  );
}

function distributionBarColumn(options?: DistributionBarOptions): GridColTypeDef {
  return {
    ...baseColumn,
    type: "custom",
    renderCell: (params: GridRenderCellParams) => {
      const theme = useTheme();
      const { i18n } = useTranslation();
      return renderDistributionBarColumn(i18n, theme, params, options);
    },
    ...(options?.headerLabels && {
      renderHeader: fieldLabelFormat(options.headerLabels)
    }),
  };
}

export default distributionBarColumn;
